<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-snackbar
        v-model="snackbar"
        xs12
        multi-line
        :timeout="timeout"
        top
        color="orange"
      >
        {{ alertmessage }}
        <v-btn
          color="white"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="warning"
          icon="mdi-cogs"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Onboard Safe Commands
            </div>
          </template>
          <v-row>
            <v-spacer />
            <v-btn
              class="mr-2"
              color="warning"
              to="/paythingsonboard"
            >
              Return
            </v-btn>
          </v-row>
          <v-card>
            <v-card-title v-if="sitedetails">
              Site Name : {{ sitedetails.idnum }} / Safe ID: {{ sitedetails.safeid }}
            </v-card-title>
            <v-card-title v-if="sitedetails">
              Last Communications: {{ sitedetails.lastcoms }}
            </v-card-title>
            <v-card-title>
              <v-card-text>
                <v-card height="100">
                  <v-autocomplete
                    v-model="onboardsite"
                    :autocomplete="Date.now()"
                    :items="getlocs"
                    color="secondary"
                    label="Safe ID*"
                    validate-on-blur
                    @change="onChangeOnboard($event)"
                  />
                </v-card>
                <v-col>
                  <v-row
                    v-if="onboarsafeselected"
                    justify="space-around"
                  >
                    <v-dialog
                      v-model="dialogtimezone"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Set Timezone
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set timezone on device</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-select
                                  v-model="timezone"
                                  :items="supportedTimezones"
                                  label="Time Zone"
                                />
                                <v-btn
                                  color="blue darken-1"
                                  block
                                  @click="sendtimezone"
                                >
                                  Send Request to Device
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogsetsafetime"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Set Time
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set time on device (UTC)</span>
                        </v-card-title>
                        <v-row justify="center">
                          <v-time-picker
                            v-model="safetime"
                            use-seconds
                            format="24hr"
                            color="primary"
                          />
                        </v-row>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closegroup"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="sendsafetime"
                          >
                            Set
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogprinter"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Set Printer
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set device printer</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-select
                                  v-model="safeprinter"
                                  :items="supportedPrinters"
                                  label="Printers"
                                />
                                <v-btn
                                  color="blue darken-1"
                                  block
                                  @click="sendsafeprinter"
                                >
                                  Send Request to Device
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogstate"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Set State
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set device state</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-select
                                  v-model="safestate"
                                  :items="supportedStates"
                                  label="Device States"
                                  @change="onChangeSafeState($event)"
                                />
                                <v-btn
                                  color="blue darken-1"
                                  block
                                  @click="sendsafestate"
                                >
                                  Send Request to Device
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogsetmode"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Set Mode
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set device mode</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-select
                                  v-model="safemode"
                                  :items="supportedModes"
                                  label="Device Modes"
                                  @change="onChangeSafeMode($event)"
                                />
                                <v-btn
                                  color="blue darken-1"
                                  block
                                  @click="sendsafemode"
                                >
                                  Send Request to Device
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogeod"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Set End of Day
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set End of Day time (UTC)</span>
                        </v-card-title>

                        <v-row justify="center">
                          <v-time-picker
                            v-model="seteod"
                            format="24hr"
                            color="primary"
                          />
                        </v-row>

                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closegroup"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="sendeodtime"
                          >
                            Set
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                  <v-row
                    v-if="onboarsafeselected"
                    justify="space-around"
                  >
                    <v-dialog
                      v-model="dialogupdatesafe"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Update Safe
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Command Safe Update</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col>
                                <v-select
                                  v-model="release"
                                  color="primary"
                                  :items="getrels"
                                  outlined
                                  label="Release Version"
                                  @change="onChangeUpdateRelease($event)"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="updateurl"
                                  color="primary"
                                  label="URL"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="updateuser"
                                  color="primary"
                                  label="User Name"
                                />
                                <v-text-field
                                  v-model="updatepass"
                                  color="primary"
                                  label="Password"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-btn
                                  color="blue darken-1"
                                  block
                                  @click="sendupdaterequest"
                                >
                                  Send Request to Device
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialoglogfiles"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Request Log Files
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Command device to upload log files</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col>
                                <v-select
                                  v-model="productlogs"
                                  color="primary"
                                  :items="targetlogs"
                                  outlined
                                  multiple
                                  label="Target Log"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="logfilepath"
                                  color="primary"
                                  label="File Path"
                                />
                                <v-text-field
                                  v-model="destinationurl"
                                  color="primary"
                                  label="URL"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="ftpuser"
                                  color="primary"
                                  label="User Name"
                                />
                                <v-text-field
                                  v-model="ftppass"
                                  color="primary"
                                  label="Password"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-btn
                                  color="blue darken-1"
                                  block
                                  @click="sendlogrequest"
                                >
                                  Send Request to Device
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogonboarddevice"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2 "
                          v-on="on"
                        >
                          Onboard Safe
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            {{ onboardsite }}
                          </div>
                          <span class="headline">Set up new device</span>
                        </v-card-title>

                        <v-card-text>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                          >
                            <v-text-field
                              v-model="customerId"
                              color="primary"
                              label="Customer ID"
                            />
                            <v-text-field
                              v-model="unitId"
                              color="primary"
                              label="Unit Name"
                            />
                            <v-select
                              v-model="timezone"
                              color="primary"
                              :items="timezonesupported"
                              outlined
                              label="Time Zone"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                          >
                            <v-menu
                              ref="menu"
                              v-model="menueodtime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="onboardEodTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="onboardEodTime"
                                  label="EOD Time"
                                  prepend-icon="mdi-clock"
                                  readonly
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="menueodtime"
                                v-model="onboardEodTime"
                                header-color="blue"
                                format="24hr"
                                full-width
                                @click:minute="$refs.menu.save(onboardEodTime)"
                              />
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                          >
                            <v-select
                              v-model="printCopies"
                              color="primary"
                              :items="numcopies"
                              outlined
                              label="Number of Copies"
                            />
                            <v-row>
                              <v-col class="xs">
                                <v-switch
                                  v-model="disabledevice"
                                  label="Disable Device"
                                  color="primary"
                                />
                              </v-col>
                              <v-col class="xs">
                                <v-switch
                                  v-model="printEod"
                                  label="Autoprint EOD"
                                  color="primary"
                                />
                              </v-col>
                            </v-row>
                            <v-slider
                              v-model="slidereodtimeout"
                              label="Deposit Timeout (S)"
                              color="primary"
                              step="5"
                              min="10"
                              max="30"
                              thumb-label="always"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                          >
                            <v-btn
                              color="blue darken-1"
                              block
                              @click="sendsafeonboard"
                            >
                              Send Request to Device
                            </v-btn>
                          </v-col>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </v-col>
              </v-card-text>
            </v-card-title>
          </v-card>
        </base-material-card>
        <v-row>
          <v-col
            md="6"
            lg="6"
          >
            <base-material-card
              v-if="!loading"
              color="warning"
              icon="mdi-nuke"
              inline
            >
              <template v-slot:after-heading>
                <div class="display-2 font-weight-light">
                  Smart Safe Reset
                </div>
              </template>
              <div
                v-if="sitedetails"
                class="display-2 font-weight-light"
              >
                Site ID: {{ sitedetails.idnum }}  Version: {{ sitedetails.version }}
              </div>
              <div
                v-if="sitedetails"
                class="display-2 font-weight-light"
              />
              <v-divider class="mt-3" />
              <v-card height="100">
                <v-select
                  v-model="resetsitedetails"
                  color="primary"
                  :items="getlocs"
                  outlined
                  label="Select Safe"
                  @change="onChange($event)"
                />
              </v-card>
            </base-material-card>
            <v-card v-if="sitedetails">
              <v-card-title>
                Smart Safe {{ sitedetails.safeid }}
                <br>Assigned to this location {{ sitedetails.idnum }}<br>Status: {{ sitedetails.status }}
                <v-card-text>
                  <v-btn
                    color="error"
                    @click="resetsafedata(sitedetails.safeid,sitedetails.idnum)"
                  >
                    RESET ALL DATA
                  </v-btn>
                  <div>
                    This will remove all transactions stored in the database from this safe. It will also remove it from the site if it is assigned.
                  </div>
                </v-card-text>
              </v-card-title>
            </v-card>
          </v-col>
          <div class="py-3" />

          <v-col
            md="6"
            lg="6"
          >
            <base-material-card
              v-if="!loading"
              color="warning"
              icon="mdi-content-duplicate"
              inline
            >
              <template v-slot:after-heading>
                <div class="display-2 font-weight-light">
                  Smart Safe Migrate
                </div>
              </template>
              <v-card>
                <v-autocomplete
                  v-model="safesource"
                  :autocomplete="Date.now()"
                  :items="getallsafes"
                  color="primary"
                  label="Original Safe"
                  validate-on-blur
                  @change="onChangeMigrateSource($event)"
                />
                <v-select
                  v-model="safesource"
                  color="primary"
                  :items="getallsafes"
                  outlined
                  label="Original Safe"
                  @change="onChangeMigrateSource($event)"
                />
                <div class="display-2 font-weight-light">
                  *WARNING ALL DATA WILL BE REPLACED*
                </div>
                <div class="display-2 font-weight-light">
                  Data will be cloned to
                </div>
                <v-autocomplete
                  v-model="safedestination"
                  :autocomplete="Date.now()"
                  :items="getallsafes"
                  color="primary"
                  label="Destination Safe"
                  validate-on-blur
                  @change="onChangeMigrateDestination($event)"
                />
                <v-select
                  v-model="safedestination"
                  color="primary"
                  :items="getallsafes"
                  outlined
                  label="Destination Safe"
                  @change="onChangeMigrateDestination($event)"
                />
                <v-card-actions>
                  <v-btn
                    color="error"
                    dark
                    class="mb-0"
                    @click="migratesafe()"
                  >
                    Clone
                  </v-btn>
                  <v-btn
                    color="black"
                    dark
                    class="mb-0"
                    @click="clearbuy()"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </base-material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Reportgroupcashin',

    data () {
      return {
        snackbar: false,
        slidereodtimeout: 20,
        onboardsite: '',
        disabledevice: false,
        safestate: '',
        safeprinter: '',
        safemode: '',
        rels: [],
        safetime: '',
        numcopies: [1, 2, 3, 4],
        timezonesupported: ['EST', 'GMT'],
        source: '',
        destination: '',
        timezone: '',
        timeout: 5000,
        alertmessage: '',
        menu: false,
        menu1: false,
        menueodtime: false,
        sitedetails: '',
        numreceipts: 0,
        productlogs: '',
        logfilepath: '',
        destinationurl: 'sftp://john-hancock.dreamhost.com/home/paythingsFTP/',
        ftpuser: 'paythingsFTP',
        ftppass: 'N3JIYwTsIv5D',
        updateurl: '',
        updateuser: '',
        updatepass: '',
        seteod: '',
        dialoggroup: false,
        dialogtime: false,
        dialogtimezone: false,
        dialogstate: false,
        dialogeod: false,
        dialogsetsafetime: false,
        dialogsetmode: false,
        dialoglogfiles: false,
        dialogupdatesafe: false,
        dialogonboarddevice: false,
        dialogprinter: false,
        resetsitedetails: '',
        filenamedate: '',
        searchdaily: '',
        safesource: '',
        safedestination: '',
        customerId: '',
        unitId: '',
        printCopies: 0,
        printEod: true,
        eodTime: '', // hh:mm
        onboardEodTime: '',
        depositTimeout: '',
        disabled: false,
        states: '',
        id: '',
        release: '',
        supportedTimezones: ['EST', 'CST', 'MST', 'PST', 'GMT'],
        supportedStates: ['goOffline', 'goOnline', 'reset', 'reboot'],
        supportedModes: ['headless', 'smart', 'hybrid'],
        supportedPrinters: ['Local Printer', 'Remote Printer'],
        targetlogs: ['iSocket', 'C3Pay', 'SmartSafe'],
        loading: false,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        groupsites: [],
        icons: true,
        editedGroupIndex: -1,
        editedGroupItem: {
          name: '',
          pin: ''
        },
        defaultGroupItem: {
          name: '',
          pin: ''
        }
      }
    },
    computed: {
      getrels () {
        this.rels = this.$store.getters.getreleases
        let list = this.$store.getters.getreleases.map(rel => rel.name)
        return list
      },
      grouplist () {
        // return []
        return this.$store.getters.usergroups
      },
      safeselected () {
        if (this.sitedetails) {
          return true
        }
        return false
      },
      onboarsafeselected () {
        if (this.onboardsite) {
          return true
        }
        return false
      },
      getallsafes () {
        let safes
        safes = this.$store.getters.ssunits.map(safe => safe.crypto_idnum)
        return safes
      },
      getsafes () {
        let safes
        safes = this.$store.getters.getheartbeatvalues.map(
          element => element.crypto_idnum
        )
        return safes
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(
          this.$store.getters.loadedSiteProfiles
        )) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug(
                  'today is ',
                  today,
                  ' Todays events ',
                  todaysevents
                )
                rejcount = todaysevents[0].rejcount
              // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
            //
            }
            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(
              element => element.crypto_idnum === safeid
            )
            let version = 'unkown'
            let lastcoms = 'NA'
            if (rec && rec.heartbeat) {
              lastcoms = moment(rec.heartbeat).format('YYYY-MM-DD HH:mm:ss')
            }
            if (rec && rec.version) {
              version = rec.version
            }
            let status = 'N/A'
            if (rec) {
              let now = Date.now()
              let delta = now - rec.heartbeat
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (delta <= 3600000) {
                status = 'Online'
              }
              if (delta >= 3600000) {
                // 60  minutes
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              safeid: safeid,
              status: status,
              rejcount: rejcount,
              sitename: name,
              version: version,
              lastcoms: lastcoms
            }
            this.locations.push(shop)
          }
        // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        this.reportingsafes = this.locations.map(element => element.safeid)
        this.$log.debug('reporting map ', this.reportingsafes)
        return this.reportingsafes
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadreleases')
    },
    methods: {
      editGroupItem (item) {
        this.$log.debug('hit edit group item')
        this.editedGroupIndex = this.currentgroups.indexOf(item)
        this.editedGroupItem = Object.assign({}, item)
        this.dialoggroup = true
      },
      deleteGroupItem (profile) {
        this.currentgroups = this.$store.getters.usergroups
        const index = this.currentgroups.indexOf(profile)
        if (
          confirm('Are you sure you want to delete this group?') &&
          this.currentgroups.splice(index, 1)
        ) {
          this.$store.dispatch('removeUserGroup', profile)
          this.$store.dispatch('loadUserGroups')
        // this.$store.dispatch('removeUserProfile', profile)
        // this.$store.dispatch('loadUserProfiles')
        }
      },
      closegroup () {
        this.dialoggroup = false
        setTimeout(() => {
          this.editedGroupItem = Object.assign({}, this.defaultGroupItem)
          this.editedGroupIndex = -1
        }, 300)
      },
      sendupdaterequest () {
        this.dialogupdatesafe = false
        let rec = {
          safeid: this.onboardsite,
          updateurl: this.updateurl,
          username: this.updateuser,
          userpass: this.updatepass
        }
        this.$store.dispatch('sendrequpdatecmd', rec)
      },
      sendlogrequest () {
        this.dialoglogfiles = false
        let rec = {
          safeid: this.onboardsite,
          productlogs: this.productlogs,
          logfilepath: this.logfilepath,
          destinationurl: this.destinationurl,
          ftpuser: this.ftpuser,
          ftppass: this.ftppass
        }
        this.$store.dispatch('sendreqlogfilescmd', rec)
      },
      sendtimezone () {
        let rec = {
          safeid: this.onboardsite,
          timezone: this.timezone
        }
        this.$store.dispatch('sendtimezonecmd', rec)
        this.dialogtimezone = false
      },
      sendsafetime () {
        let rec = {
          safeid: this.onboardsite,
          safetime: this.safetime,
        }
        this.$store.dispatch('sendsettimecmd', rec)
        this.dialogsetsafetime = false
      },
      sendeodtime () {
        let rec = {
          safeid: this.onboardsite,
          eodtime: this.seteod
        }
        this.dialogeod = false
        this.$store.dispatch('sendseteodcmd', rec)
      },
      sendsafestate () {
        let rec = {
          safeid: this.onboardsite,
          state: this.safestate
        }
        this.dialogstate = false
        this.$store.dispatch('sendsafestatecmd', rec)
      },
      sendsafemode () {
        let rec = {
          safeid: this.onboardsite,
          Mode: this.safemode
        }
        this.dialogsetmode = false
        this.$store.dispatch('sendsafemodecmd', rec)
      },
      sendsafeprinter () {
        let rec = {
          safeid: this.onboardsite,
          printer: this.safeprinter
        }
        this.dialogprinter = false
        this.$store.dispatch('sendsafeprintercmd', rec)
      },
      sendsafeonboard () {
        let rec = {
          customerId: this.customerId,
          unitId: this.unitId,
          printCopies: this.printCopies,
          printEod: this.printEod,
          // eodTime: this.eodTime, // hh:mm
          eodTime: this.onboardEodTime,
          timezone: this.timezone,
          depositTimeout: this.slidereodtimeout,
          disabled: this.disabledevice,
          safeid: this.onboardsite
        }
        this.dialogonboarddevice = false
        this.$store.dispatch('sendonboardcmd', rec)
      },
      migratesafe () {
        let rec = {
          source: this.source,
          destination: this.destination
        }
        this.$store.dispatch('migrateallsafedata', rec)
        this.alertmessage =
          'Safe ' + this.source + ' was cloned to ' + this.destination
        this.snackbar = true
      },

      saveuser () {
        this.$log.debug('group to edit was ', this.editedGroupItem)
        const userData = {
          safeid: this.editedGroupItem.safeid,
          name: this.editedGroupItem.name,
          pin: this.editedGroupItem.pin
        }
        if (this.editedGroupIndex > -1) {
          this.$store.dispatch('updateSafeUser', userData)
          // this.$store.dispatch('updateUserProfile', userData)
          Object.assign(
            this.currentgroups[this.editedGroupIndex],
            this.editedGroupItem
          )
        } else {
          this.$log.debug('there is no else')
          // this.$store.dispatch('createSafeUser', groupData.name)
        }
        this.$store.dispatch('loadSafeUsers')
        this.closegroup()
      },
      closeAddUser () {
        this.dialoggroup = false
        setTimeout(() => {
          this.editedGroupItem = Object.assign({}, this.defaultGroupItem)
          this.editedGroupIndex = -1
        }, 300)
      },
      resetsafedata (crypto_idnum, idnum) {
        this.$log.debug('details to reset ', crypto_idnum, idnum)
        let rec = {
          safeid: crypto_idnum,
          siteidnum: idnum
        }
        this.alertmessage =
          'Safe ' + crypto_idnum + ' was unassigned and all data was removed'
        this.snackbar = true
        this.$store.dispatch('resetallsafedata', rec)
        this.$store.dispatch('loadunits')
        this.$store.dispatch('loadsiteProfiles')
        this.$store.dispatch('loadUserGroups')
        this.$store.dispatch('loadSiteConfigs')
        this.sitedetails = ''
      },
      onResetChange (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug('loaded sites ', this.$store.getters.loadedSites)
        this.sitedetails = this.locations.find(site => site.safeid === value)
      },
      onChangeSafeState (value) {
        this.safestate = value
      },
      onChangeSafeMode (value) {
        this.safemode = value
      },
      onChangeUpdateRelease (value) {
        this.updateurl = this.rels.find(rel => rel.name === value).path
      },
      onChange (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug('loaded sites ', this.$store.getters.loadedSites)
        this.sitedetails = this.locations.find(site => site.safeid === value)
      },
      onChangeOnboard (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug(
          'on change onboard loaded sites ',
          this.$store.getters.loadedSites
        )
        this.onboardsite = this.locations.find(
          site => site.safeid === value
        ).safeid
        this.sitedetails = this.locations.find(site => site.safeid === value)
      },
      onChangeMigrateSource (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug(
          'on change onboard loaded sites ',
          this.$store.getters.loadedSites
        )
        this.source = value
      },
      onChangeMigrateDestination (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug(
          'on change onboard loaded sites ',
          this.$store.getters.loadedSites
        )
        this.destination = value
      },
      getsitesbygroup (group) {
        this.locations = []
        for (let [key, value] of Object.entries(
          this.$store.getters.loadedSiteProfiles
        )) {
          let grp = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            grp = loc.group
          }
          this.$log.debug(' our group is ', value.group, ' passed was ', grp)
          if (value.siteunitsprofile && value.group === grp) {
            this.$log.debug('adding')
            let shop = {
              idnum: key,
              safeid: Object.values(value.siteunitsprofile)[0].crypto_idnum
            }
            this.locations.push(shop)
          }
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
      // loop thru, find name
      // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
